import ColorSwatch from '../../../../ColorSwatch/ColorSwatch';
import React, { useState } from 'react';
import ActionButtons from './ActionButtons';

type ColorItem = { color: string; title: string };

// Mirrors ColorSwatch's defaultPalette — used to resolve hex → title on init
const COLOR_PALETTE: ColorItem[] = [
  { color: '#E53935', title: 'Red' },
  { color: '#FB8C00', title: 'Orange' },
  { color: '#FDD835', title: 'Yellow' },
  { color: '#E900B0', title: 'Pink' },
  { color: '#43A047', title: 'Green' },
  { color: '#33C3C0', title: 'Turquoise' },
  { color: '#1E88E5', title: 'Blue' },
  { color: '#8E24AA', title: 'Purple' },
  { color: '#773410', title: 'Brown' },
  { color: '#FFFFFF', title: 'White' },
  { color: '#9E9E9E', title: 'Gray' },
  { color: '#212121', title: 'Black' },
  { color: 'transparent', title: 'Transparent' },
];

const hexToColorItem = (hex: string): ColorItem => {
  const match = COLOR_PALETTE.find(p => p.color.toLowerCase() === hex.toLowerCase());
  return match || { color: hex, title: hex };
};

interface ColorFilterDropdownProps {
  linkedSpaces: string[];
  closeDropdown: () => void;
  setAiSuggestions: (suggestions: any) => void;
  ai_suggestions: any;
  warning?: string;
}

const ColorFilterDropdown: React.FC<ColorFilterDropdownProps> = ({ linkedSpaces, ai_suggestions, setAiSuggestions, closeDropdown, warning }) => {
  // Store { color, title } objects (dam-ui parity); ai_suggestions.color persists plain hex strings
  const [selectedColors, setSelectedColors] = useState<ColorItem[]>(
    Array.isArray(ai_suggestions?.color)
      ? ai_suggestions.color.map((c: string) => hexToColorItem(c))
      : []
  );

  // dam-ui parity: single-select — take only the last selected color
  const handleSelect = (colors: ColorItem[]) => {
    const singleColor = colors.length > 0 ? [colors[colors.length - 1]] : [];
    setSelectedColors(singleColor);
  };

  const applyFilter = () => {
    if (selectedColors.length > 0) {
      setAiSuggestions({
        ...(ai_suggestions || {}),
        color: selectedColors.map(c => c.color), // store hex strings (dam-ui parity)
        space_uids: linkedSpaces,
      });
    } else {
      const updatedSuggestions = { ...(ai_suggestions || {}) };
      delete updatedSuggestions.color;
      setAiSuggestions(updatedSuggestions);
    }
    closeDropdown();
  };

  const clearAll = () => {
    setSelectedColors([]);
  };

  return (
    <div className="color-filter-dropdown">
      <ColorSwatch
        key={selectedColors.map(c => c.color).join(',')}
        title={'Select a color to filter assets quickly'}
        selectedColors={selectedColors}
        handleSelect={handleSelect}
        version="basic"
        multiple={false}
        includeDetails={true}
        warning={warning}
      />
      <ActionButtons
        closeDropdown={closeDropdown}
        clearAll={clearAll}
        applyFilter={applyFilter}
      />
    </div>
  );
};

export default ColorFilterDropdown;
